import { render, staticRenderFns } from "./Consultorios.vue?vue&type=template&id=187289e8&scoped=true"
import script from "./Consultorios.vue?vue&type=script&lang=js"
export * from "./Consultorios.vue?vue&type=script&lang=js"
import style0 from "./Consultorios.vue?vue&type=style&index=0&id=187289e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187289e8",
  null
  
)

export default component.exports